import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './StripePaymentTerms.scss';

export interface Props {
  className?: string;
}

const StripePaymentTerms: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['terms']}>
        {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.prefix')}{' '}
        <a
          href="https://www.deviantart.com/about/policy/service/"
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(
            'studio.earnings.stripe.withdraw.modal.finePrint.terms.deviantart'
          )}
        </a>
        {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.and')}{' '}
        <a
          href="https://stripe.com/legal/connect-account/recipient"
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('studio.earnings.stripe.withdraw.modal.finePrint.terms.stripe')}
        </a>
        .
      </div>
    </div>
  );
};

StripePaymentTerms.displayName = 'StripePaymentTerms';

export default StripePaymentTerms;
